import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {CardContainer} from 'components/common/uiKit';

const data = [
    {
        id: 1,
        size: 12,
        icon: 'fa-credit-card',
        color: 'color-mint-dark',
        title: 'Bills',
        link: '/app/admin/bills'
    },
    {
        id: 2,
        size: 12,
        icon: 'fa-object-group',
        color: 'color-blue2-dark',
        title: 'CMS',
        link: '/app/admin/cms/course'
    }
];

class Main extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    handleItemClick = (link) => {
        this.props.history.push({pathname: link});
    };

    handleItems = ({size, icon, color, title, link}) => {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.Main.MenuItems;

        return (
            <div className={`col-lg-${size}`} onClick={this.handleItemClick.bind(this, link)}>
                <CardContainer>
                    <div className='text-center'>
                        <i className={`fa ${icon} font-40 ${color}`}/>
                        <h5 className={`text-center mt-3 ${color}`}>
                            {pageTranslates[title]}
                        </h5>
                    </div>
                </CardContainer>
            </div>
        );

    };

    render() {
        return (
            <div className='row'>
                {data.map(item => this.handleItems(item))}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Main));

